import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_OPPORTUNITIES_OVERVIEW = "/opportunities/overview";
export const REDIRECT_TO_OPPORTUNITY_DETAIL = "/opportunities/details";

export const opportunitiesPage = {
  id: "Opportunities",
  label: "Opportunities",
  icon: "visualizeApp",
  path: "/opportunities",
  isSingle: true,
  items: [
    {
      label: "Overview",
      path: "/opportunities/overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Alerts_Dashboard,
        role: Roles.Read,
      },
      topLabel: <></>,
      topNavLinks: [
        {
          label: "Overview",
          path: "/opportunities/overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/opportunities/details",
          requireClientSelection: true,
        },
      ],
    },
  ],
};
